import React from 'react';
import { Typography, Card, CardContent, Box, Button, Stack } from '@mui/joy';
import { useAuth } from '../../context/AuthContext';
import MainLayout from '../../components/Layout/MainLayout';

const SettingsPage = () => {
  const { user, isAdmin } = useAuth();

  return (
    <MainLayout currentPage="settings">
      <Box>
        <Typography level="h2" sx={{ fontWeight: 600, mb: 3 }}>
          Settings
        </Typography>
        
        <Stack spacing={3}>
          <Card variant="outlined">
            <CardContent>
              <Typography level="title-lg" sx={{ mb: 2 }}>
                Account Settings
              </Typography>
              <Stack direction="row" spacing={2}>
                <Button
                  variant="outlined"
                  onClick={() => window.location.href = '/change-password'}
                >
                  Change Password
                </Button>
                <Button variant="outlined" disabled>
                  Update Profile (Coming Soon)
                </Button>
              </Stack>
            </CardContent>
          </Card>
          
          {isAdmin() && (
            <Card variant="outlined">
              <CardContent>
                <Typography level="title-lg" sx={{ mb: 2 }}>
                  System Administration
                </Typography>
                <Stack direction="row" spacing={2}>
                  <Button
                    variant="outlined"
                    onClick={() => window.location.href = '/users'}
                  >
                    Manage Users
                  </Button>
                  <Button variant="outlined" disabled>
                    System Settings (Coming Soon)
                  </Button>
                </Stack>
              </CardContent>
            </Card>
          )}
          
          <Card variant="outlined">
            <CardContent sx={{ textAlign: 'center', py: 4 }}>
              <Box sx={{ fontSize: '3rem', mb: 2 }}>⚙️</Box>
              <Typography level="title-lg" sx={{ mb: 1 }}>
                More Settings Coming Soon
              </Typography>
              <Typography level="body-md" sx={{ color: 'neutral.600' }}>
                Additional system configuration options will be available here.
              </Typography>
            </CardContent>
          </Card>
        </Stack>
      </Box>
    </MainLayout>
  );
};

export default SettingsPage;